import {injectable} from "inversify";
import {MoveSpeedMode, Player} from "@/store/player/types";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {PlayerActionButton} from "@/scenes.ui/player-action-button";
import PlayerStore from "@/store/player";
import {Tr} from "@/i18n/i18n";
import {IntegrationUtils} from "@/utils/integration-utils";
import {TechUtils} from "@/utils/tech-utils";

@injectable()
export class PlayerSpeedService {

    public static readonly DEFAULT_BIG_SPEED: number = TechUtils.isBigSpeed() ?  7.2 : 3.6;
    private scene!: Scene;

    public init(scene: Scene) {
        this.scene = scene;
    }

    public getSpeedMultiplier() {
        let moveSpeedMode: MoveSpeedMode = PlayerStore.getMoveSpeedMode();
        switch (moveSpeedMode) {
            case MoveSpeedMode.DEFAULT_MODE:
                return 1;
            case MoveSpeedMode.DOUBLED_MODE:
                return PlayerSpeedService.DEFAULT_BIG_SPEED / PlayerStore.getPlayer().speed;
        }
        return 1;
    }

    public async changeCurrentSpeedMode(moveSpeedButton: PlayerActionButton) {
        await PlayerStore.changeMoveSpeedMode().then((p: Player) => {
            this.showFeedBackPanel(p.moveSpeedMode);
            this.determineMoveSpeedButtonPrefs(moveSpeedButton);
        });
    }

    public getPlayerSpeedByMultiplier(): number {
        let speedMultiplier = this.getSpeedMultiplier();
        return PlayerStore.getPlayer().speed * speedMultiplier;
    }

    public determineMoveSpeedButtonPrefs(moveSpeedButton: PlayerActionButton) {
        let moveSpeedMode: MoveSpeedMode = PlayerStore.getMoveSpeedMode();
        switch (moveSpeedMode) {
            case MoveSpeedMode.DEFAULT_MODE:
                moveSpeedButton.setButtonImage(Keys.ATLAS_UI, Keys.UI_PROFILE_BOOTS_OFF);
                moveSpeedButton.setButtonText(Tr('nadet.sapogi.skorohodi'));
                break;
            case MoveSpeedMode.DOUBLED_MODE:
                moveSpeedButton.setButtonImage(Keys.ATLAS_UI, Keys.UI_PROFILE_BOOTS_ON);
                moveSpeedButton.setButtonText(Tr('snjat.sapogi.skorohodi'));
                break;
        }
    }

    private showFeedBackPanel(speedMode: MoveSpeedMode) {
        switch (speedMode) {
            case MoveSpeedMode.DEFAULT_MODE:
                return new FeedbackPanel(this.scene, Tr('sapogiskorohodi.snjati'), undefined, false).show();
            case MoveSpeedMode.DOUBLED_MODE:
                return new FeedbackPanel(this.scene, Tr('sapogiskorohodi.nadeti'), undefined, true).show();
        }
        throw new TypeError();
    }
}
